module.exports = __webpack_public_path__ + "static/img/in-tpl-life.32ed0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/in-tpl-life.png
// module id = xz2a
// module chunks = 1